<template>
  <div class="container">
    <div class="content">
      <!-- 顶部按钮 -->
      <div class="button-layout">
        <p class="cancel-btn" @click.prevent="onCancel">取消</p>
        <p class="confirm-btn" :class="{active: inputContent.trim().length > 0}" @click.prevent="onConfirm">确认</p>
      </div>
      <!-- 学校列表 -->
      <div class="school-list">
        <p class="school-title">学校名称</p>
        <input class="school-input" type="text" placeholder="填写学校名称，校友助你高效求职" v-model="inputContent">
        <div class="clear-layout" v-if="inputContent.trim().length > 0" @click.prevent="onClear()">
           <span class="iconfont iconx clear-btn" />
        </div>
        <!-- 大学列表 -->
        <div class="item-layout">
        <div v-for="(item, index) in schoolList" :key="index" class="school-item" @click="onItemClick(item)">
          <p v-html="item.highlight"></p>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { componentsMixin } from '../../../assets/js/mixin/components';
import { envMixin } from '../../../assets/js/mixin/global';
import { userMixin } from '../../../assets/js/mixin/user';
import { mapState, mapActions } from "vuex";

export default {
  name: "picker-school",
  mixins: [componentsMixin, envMixin, userMixin],
  data() {
    return {
      inputContent: '', // 输入框内容
      schoolList: [], // 学校列表
      selectedSchool: null, // 当前已选中的学校
    }
  },
  computed: {
  },
  watch: {
    inputContent: function() {
      if (this.inputContent.trim().length > 0) {
        this.fetchUniversityList();
      } else {
        this.schoolList = [];
        this.selectedSchool = null;
      }
    }
  },
  created() {

  },
  methods: {
    // 取消
    onCancel() {
      this.$emit("handleClose");
    },
    // 确认
    onConfirm() {
      console.log("confirm...", this.inputContent);
      if (!this.inputContent) return;

      let params = this.selectedSchool ? this.selectedSchool : {name: this.inputContent};
      this.$emit("receiveSchoolItem", params);
    },
    // 清除输入框内容
    onClear() {
      this.inputContent = "";
      this.schoolList = [];
      this.selectedSchool = null;
    },
    onItemClick(item) {
      console.log(item.name)
      this.inputContent = item.name;
      this.selectedSchool = item;
    },
    // 根据关键词获取大学名称
    async fetchUniversityList() {
      try {
        let res = await this.$api.staticApi.universityComplete({
          keyword: this.inputContent
        })
        if (res.code === 1000) {
          this.schoolList = res.data;
        }
      } catch (e) {
        console.log('大学自动补全 错误', e)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .container {
    width: 100%;
    .content {
      display: flex;
      flex-direction: column;
      flex: 1;
      height: 85vh;
      .button-layout {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .cancel-btn {
          color: #9C9C9C;
          font-size: 16px;
          padding: 31px 24px;
        }
        .confirm-btn {
          color: #CFCFCF;
          font-size: 16px;
          padding: 31px 24px;
          &.active {
            color: #FF6644;
          }
        }
      }
      .school-list {
        padding: 8px 24px;
        display: flex;
        flex-direction: column;
        height: 100%;
        flex: 1;
        .school-title {
          color: #606060;
          font-size: 12px;
        }
        .school-input {
          padding: 8px 0px;
          border: none;
          caret-color: #FF6644;
          border-bottom: 1px solid #FF6644;
          color: #404040;
          font-size: 15px;
        }
        .clear-layout {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;
          right: 0;
          margin-right: 24px;
          margin-top: 20px;
          background: #CFCFCF;
          .clear-btn {
            color: #fff;
          }
        }
        .item-layout {
          overflow: auto;
          height: calc(90vh - 78px - 60px);
          .school-item {
          padding: 14px 0px;
          border-bottom: 1px solid #f9f9f9;
          color: #9c9c9c;
          font-size: 14px;
          }
          ::v-deep.es-highlighter {
            color: #FF6644;
            font-size: 14px;
          }
        }
        .item-layout::-webkit-scrollbar {
          display: none;
        }
      }
    }
  }
</style>